var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 338.51 297.23",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 84.63,
    y1: 295.19,
    x2: 253.89,
    y2: 2.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e58e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#db2d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.56,290.47l-22.92-39.7a5.28,5.28,0,0,1,0-4.65l25.45-44.07a5.24,5.24,0,0,1,4.06-2.35h50.89a5.26,5.26,0,0,1,4.07,2.35l25.45,44.07a5.32,5.32,0,0,1,0,4.7l-25.45,44.07a5.33,5.33,0,0,1-4,2.34H91.36A15.43,15.43,0,0,1,79.56,290.47Zm165.27-90.69L194.13,112a7.21,7.21,0,0,0-5.56-3.21H87.17A7.21,7.21,0,0,0,81.61,112l-50.7,87.82a7.18,7.18,0,0,0,0,6.42L45.77,232l26-45a8.22,8.22,0,0,1,6.43-3.72H145a8.22,8.22,0,0,1,6.43,3.72l33.41,57.86a8.24,8.24,0,0,1,0,7.43l-26,45h29.7a7.19,7.19,0,0,0,5.56-3.22l50.7-87.81A7.18,7.18,0,0,0,244.83,199.78Zm92-58.09L259.06,6.93a15.37,15.37,0,0,0-12-6.93H91.45a15.37,15.37,0,0,0-12,6.93L1.65,141.69a15.36,15.36,0,0,0,0,13.85l17.83,30.88,51.7-89.56a10.14,10.14,0,0,1,7.94-4.58H196.53a10.14,10.14,0,0,1,7.94,4.58l58.71,101.69a10.13,10.13,0,0,1,0,9.16l-51.69,89.52h35.57a15.37,15.37,0,0,0,12-6.93l77.8-134.76A15.36,15.36,0,0,0,336.86,141.69Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHex);
export default __webpack_public_path__ + "static/media/hex.15714eba204ed56e0c748e829e8d691e.svg";
export { ForwardRef as ReactComponent };